<div class="flex-container">
  <div class="ml-auto">
    @if (canEdit) {
      <button type="button" mat-raised-button (click)="onAddFindMeFollowMeStepClick()">Add Step</button>
    }
  </div>
</div>

<ul cdkDropList [cdkDropListDisabled]="!canEdit" class="route-item-list" (cdkDropListDropped)="drop($event)">
  @for (findMeFollowMeStep of findMeFollowMeSteps; track findMeFollowMeStep; let findMeFollowMeStepsIndex = $index) {
    <li cdkDrag>
      @if (!findMeFollowMeStep.isDeleted) {
        <div class="route-item">
          @if (canEdit) {
            <mat-icon class="draggable" aria-label="reorder drag handle" cdkDragHandle
              >drag_indicator</mat-icon
              >
            }
            <div class="route-description-wrapper">
              <div class="route-title"> Step {{ findMeFollowMeStep.sequence }} </div>
              <div class="route-description">
                @if (findMeFollowMeStep.extensionsOrPhoneNumbersToDial?.length > 0) {
                  <mat-chip-set style="width: 100%">
                    <strong>Dialing: </strong>
                    @for (value of findMeFollowMeStep.extensionsOrPhoneNumbersToDial; track value; let i = $index) {
                      @if (!value.isDeleted) {
                        <mat-chip-option style="margin-right: 0.25em" [disableRipple]="true">
                          {{ value | formatPhoneNumberOrExtension }}
                        </mat-chip-option>
                      }
                    }
                  </mat-chip-set>
                }
                <div style="width: 25%">
                  <strong>Timeout: </strong>
                  <span>{{ findMeFollowMeStep.timeout }} seconds</span>
                </div>
              </div>
            </div>
            <div class="route-actions">
              <button
                type="button"
                aria-label="Time Based Route Actions"
                matTooltip="More Actions"
                mat-icon-button
                [matMenuTriggerFor]="routeListItemMenu"
                [matMenuTriggerData]="{ $implicit: findMeFollowMeStep, index: findMeFollowMeStepsIndex }"
                [disabled]="disabled"
                id="time-based-route-list-option-menu-button-{{ findMeFollowMeStepsIndex }}"
                >
                <mat-icon> more_vert </mat-icon>
              </button>
              <mat-menu #routeListItemMenu="matMenu">
                <input type="hidden" />
                <button
                  mat-menu-item
                  type="button"
                  id="menu-edit"
                  (click)="onEditFindMeFollowMeStepClick(findMeFollowMeStepsIndex)"
                  >
                  Edit
                </button>
                <button mat-menu-item type="button" id="menu-delete" (click)="onDeleteClick(findMeFollowMeStepsIndex)">
                  Delete
                </button>
              </mat-menu>
            </div>
          </div>
        }
      </li>
    }
    @if (!findMeFollowMeSteps || findMeFollowMeSteps.length === 0) {
      <span>No Steps Set</span>
    }
  </ul>
